// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1eGL2","question":"Question_question__MQXzf","description":"Question_description__2uaVC"};